// extracted by mini-css-extract-plugin
export default {"test_card":"PartSurveyReport_test_card__eK8km","btn_print":"PartSurveyReport_btn_print__LLj2I","div_print":"PartSurveyReport_div_print__EkxkN"};